import { TextBooleanItemInterface } from '@/types/newTypes'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { CheckSvgIcon } from './ui/Icons'
import ScanCompletedModal from './screens/ScanCompletedModal'
import { trackAmplitudeEvent, trackCustomizeProduct } from '@/helpers/facebookPixelEvents'

export const ScanResults = () => {
  const [progressValue, setProgressValue] = useState<number>(0)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [items, setItems] = useState<TextBooleanItemInterface[]>([
    {
      text: 'Analyzing your gallery',
      boolean: false,
    },
    {
      text: 'Identifying duplicates and similar photos',
      boolean: false,
    },
    {
      text: 'Connecting to the phone',
      boolean: false,
    },
  ])

  const setElementActive = (index: number) => {
    setItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, boolean: true } : item)),
    )
  }
  useEffect(() => {
    trackCustomizeProduct()
    trackAmplitudeEvent('2nd_screen')
  }, [])

  useEffect(() => {
    if (isLoaded) {
      const startTime = Date.now()
      const duration = 7100
      const interval = 20

      const updateProgress = setInterval(() => {
        const elapsed = Date.now() - startTime
        let progress

        if (elapsed < 1420) {
          progress = (elapsed / 1420) * 10
        } else if (elapsed < 5680) {
          progress = 10 + ((elapsed - 1420) / 4260) * 80
        } else {
          progress = 90 + ((elapsed - 5680) / 1420) * 10
        }

        setProgressValue(Math.min(progress, 100))

        if (elapsed >= 2800 && elapsed < 2820) setElementActive(0)
        if (elapsed >= 4680 && elapsed < 4700) setElementActive(1)
        if (elapsed >= 7020 && elapsed < 7040) setElementActive(2)

        if (elapsed >= duration) clearInterval(updateProgress)
      }, interval)

      return () => clearInterval(updateProgress)
    }
  }, [isLoaded])

  return (
    <section className="pb-10">
      <div
        className={clsx('fixed top-0 left-0 w-full h-full bg-black z-10', {
          'pointer-events-none opacity-0': isLoaded,
          'pointer-events-auto opacity-100': !isLoaded,
        })}
      >
        <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
          <svg viewBox="0 0 100 100" height="76" className="animate-spin">
            <use href="/svg/sprite.svg#spinner"></use>
          </svg>
        </div>
      </div>
      <div className="w-full aspect-[375/432] mb-1.5">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          onLoadedData={() => setIsLoaded(true)}
        >
          <source src="/video/1.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="max-w-content mx-auto px-4">
        <h2 className="mb-[22px] text-center text-XL font-bold">Scanning for...</h2>
        <div className="flex flex-col gap-4 px-2 box-border">
          {items.map((item, index) => (
            <div className="flex flex-row gap-3" key={index}>
              <div className="relative w-6 h-6 transition duration-200 ease-out border-2 border-grayText rounded-full">
                <CheckSvgIcon
                  className={clsx(
                    'absolute -top-0.5 -left-0.5 w-6 h-6 opacity-0 transition-opacity duration-200 ease-out',
                    {
                      'opacity-0': !item.boolean,
                      'opacity-100': item.boolean,
                    },
                  )}
                />
              </div>
              <p
                className={clsx('text-logo transition-colors duration-200 ease-out', {
                  'text-grayText': !item.boolean,
                  'text-white': item.boolean,
                })}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>
        <div className="px-2">
          <div className="w-full relative transition-all ease-out overflow-hidden h-2 mt-8 rounded-2xl bg-white15">
            <div
              className="absolute h-full bg-yellow rounded-2xl top-0 left-0"
              style={{ width: `${progressValue}%` }}
            ></div>
          </div>
        </div>
      </div>
      <ScanCompletedModal
        hideCondition={progressValue < 100}
        showCondition={progressValue === 100}
      />
    </section>
  )
}
